import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { EquipmentAttachment } from '@core/interfaces';

@Injectable({
  providedIn: 'root'
})
export class EquipmentsAttachmentsApi {
  constructor(private readonly apollo: Apollo) { }

  createEquipmentAttachment(input: any): Observable<EquipmentAttachment> {
    return this.apollo
    .query({
      query: gql`
        mutation createEquipmentAttachment($input: EquipmentAttachmentInput!) {
          createEquipmentAttachment(input: $input) {
            id
            title
            path
            size
            createdAt
          }
        }
      `,
      variables: {
        input
      }
    })
    .pipe(map((response) => response.data['createEquipmentAttachment'] as EquipmentAttachment));
  }

  updateEquipmentAttachment(id: string, input: any): Observable<EquipmentAttachment> {
    return this.apollo
      .query({
        query: gql`
          mutation updateEquipmentAttachment($id: ID!, $input: EquipmentAttachmentInput!) {
            updateEquipmentAttachment(id: $id, input: $input) {
              id
            }
          }
        `,
        variables: {
          id,
          input
        }
      })
      .pipe(map((response) => response.data['updateEquipmentAttachment'] as EquipmentAttachment));
  }

  deleteEquipmentAttachment(id: string): Observable<EquipmentAttachment> {
    return this.apollo
      .query({
        query: gql`
          mutation deleteEquipmentAttachment($id: ID!) {
            deleteEquipmentAttachment(id: $id) {
              id
            }
          }
        `,
        variables: {
          id
        }
      })
      .pipe(map((response) => response.data['deleteEquipmentAttachment'] as EquipmentAttachment));
  }
}
